import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { SearchType } from '@studyportals/search-page-interface';

export class SearchPageReadyToLoadSearch implements IEvent {
	public static readonly EventType = 'SearchPage:ReadyToLoadSearch';

	public readonly timestamp = new Date();
	public readonly eventType = SearchPageReadyToLoadSearch.EventType;
	public readonly searchType: SearchType;
	public readonly onSwitchSearchType: boolean;

	public constructor(searchType: SearchType, onSwitchSearchType: boolean) {
		this.searchType = searchType;
		this.onSwitchSearchType = onSwitchSearchType;
	}

	public static is(event: IEvent): event is SearchPageReadyToLoadSearch {
		return event.eventType === SearchPageReadyToLoadSearch.EventType;
	}
}
